import {
    QUIZ_NEXT_STEP,
    QUIZ_REQUEST_DATA,
    QUIZ_CHANGE_ANSWERS,
    QUIZ_PREV_STEP,
    QUIZ_SHOW_TARIFF,
    QUIZ_ERROR,
    QUIZ_SET_TARIFF,
    QUIZ_CLEAR_QUESTIONS,
    QUIZ_SET_IS_SENDED,
    QUIZ_SET_IS_SHOW,
    QUIZ_SEND_ERROR,
    QUIZ_SET_TARIFFS,
    QUIZ_SET_ROUTER,
    QUIZ_SET_TV_BOX
} from '../actionTypes/quiz';

import { getQuiz } from '~/src/api/content/quiz';

export const nextStepAction = (stepNumber) => ({
    type: QUIZ_NEXT_STEP,
    payload: stepNumber
});

export const prevStepAction = () => ({
    type: QUIZ_PREV_STEP
});

export const getQuizData = (domain, aliasForQuiz, pointEntry = null) => {
    return async(dispatch) => {
        const resp = await getQuiz(domain, aliasForQuiz);

        if (resp.isSuccess) {
            const quizData = resp.payload;
            const quizInfo = {
                alias: quizData.alias,
                available: quizData.available,
                available_auth: quizData.available_auth,
                available_new: quizData.available_new,
                title: quizData.title,
                pointEntry,
            };

            dispatch(({
                type: QUIZ_REQUEST_DATA,
                payload: {
                    questions: quizData.questions || [],
                    quiz: quizInfo
                },
            }));
        }
    };
};

export const requestDataAction = (questions, quiz) => ({
    type: QUIZ_REQUEST_DATA,
    payload: {
        questions,
        quiz
    }
});

export const changeAnswersAction = (questions) => ({
    type: QUIZ_CHANGE_ANSWERS,
    payload: {
        questions
    }
});

export const showTariffAction = (show = true) => ({
    type: QUIZ_SHOW_TARIFF,
    payload: show
});

export const showErrorAction = (show) => ({
    type: QUIZ_ERROR,
    payload: show
});

export const setTariffAction = tariff => ({
    type: QUIZ_SET_TARIFF,
    payload: tariff
});

export const setRouterAction = router => ({
    type: QUIZ_SET_ROUTER,
    payload: router
});

export const setTvBoxAction = tvBox => ({
    type: QUIZ_SET_TV_BOX,
    payload: tvBox
});

export const clearQuestionsAction = questions => ({
    type: QUIZ_CLEAR_QUESTIONS,
    payload: questions
});

export const isSendedActions = (isSended, name = '')=> ({
    type: QUIZ_SET_IS_SENDED,
    payload: isSended,
    name
});

export const isShowQuizActions = isShowQuiz => ({
    type: QUIZ_SET_IS_SHOW,
    payload: isShowQuiz
});

export const isSendErrorActions = isSendError => ({
    type: QUIZ_SEND_ERROR,
    payload: isSendError
});

export const setTariffsForQuizAction = tariffs => ({
    type: QUIZ_SET_TARIFFS,
    payload: tariffs
});
